
const HeroSection = () => {
  const features = [
    {
      number: '1732次成功',
      description: '帮助1732名学生拿到全球offer'
    },
    {
      number: '百万年薪',
      description: '毕业生中已有569人超过百万年薪'
    },
    {
      number: '360万年包',
      description: '最高年薪来自Jump Trading的50万美金(360万人民币)'
    },
    {
      number: '400+常青藤',
      description: '拿到超过400个常青藤offer'
    },
    {
      number: '13位院士',
      description: '13位院士+217名教授与我们携手共创'
    },
    {
      number: '纽约时报',
      description: '登上人民日报、纽约时报等多家海内外权威媒体'
    }
  ];

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/4b17ff4ce11e83e03cb21bca7be9287e.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 py-20">
        <div className="text-center text-white">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            逃离内卷，规划全球上升新职路
          </h2>
          <p className="text-xl md:text-2xl mb-12 text-gray-200 max-w-3xl mx-auto">
            专注全球高价值高增长职业规划，求职、留学、移民全链路服务
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-16">
            {features.map((feature, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-6 border border-white/20">
                <div className="text-lg md:text-3xl font-bold text-blue-300 mb-1 md:mb-2">
                  {feature.number}
                </div>
                <p className="text-gray-200 text-xs md:text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12">
            <a 
              href="#assessment"
              className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即免费评估
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
